function strictEqual(a, b) {
  return a === b;
}

strictEqual.op = '===';

export default strictEqual;
